const userTriggerInputFields = [
  {
    name: 'active',
    label: 'Envios Habilitados',
    type: 'checkbox',
  },
];

export default userTriggerInputFields;
